module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/device_desktop_2-0670f012adedcb0898d52ca3e10e1bd5.webp";